import type { GreetingPart } from '../../api/scan.js';

/** 05:00–11:59 morning, 12:00–16:59 noon, 17:00–04:59 evening, Israel time. */
export function greetingPartNow(now: Date = new Date()): GreetingPart {
  const hour = Number(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Jerusalem', hour: '2-digit', hourCycle: 'h23',
  }).format(now));
  if (hour >= 5 && hour < 12) return 'MORNING';
  if (hour >= 12 && hour < 17) return 'NOON';
  return 'EVENING';
}
